module.exports = __webpack_public_path__ + "img/89.ae80350a.jpg";